import { Status } from 'civic-champs-shared/api/hooks/fetchRefactoredSchema'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'

export interface ApiKey {
  id: number
  name: string
  token: string
  personId: number
  organizationId: number
}

export const useCreateApiKey = (): [(name?: string) => Promise<ApiKey>, Status<ApiKey>] => {
  const [request, status] = useFetchRefactored<ApiKey>()
  const organization = useCurrentOrg()

  const createApiKey = useCallback(
    (name = 'default') => {
      return request({
        method: 'post',
        url: `/organizations/${organization.id}/api-keys`,
        config: {
          body: { name },
        },
      })
    },
    [organization.id, request],
  )

  return [createApiKey, status]
}

export const useGetApiKeys = (): [() => Promise<ApiKey[]>, Status<ApiKey[]>] => {
  const [request, status] = useFetchRefactored<ApiKey[]>()
  const organization = useCurrentOrg()

  const getApiKeys = useCallback(() => {
    return request({
      method: 'get',
      url: `/organizations/${organization.id}/api-keys`,
    })
  }, [organization.id, request])

  return [getApiKeys, status]
}

export const useDeleteApiKey = (): [(token: string) => Promise<void>, Status<void>] => {
  const [request, status] = useFetchRefactored<void>()
  const organization = useCurrentOrg()

  const deleteApiKey = useCallback(
    token => {
      return request({
        method: 'del',
        url: `/organizations/${organization.id}/api-keys/${token}`,
      })
    },
    [organization.id, request],
  )

  return [deleteApiKey, status]
}
